import React, { useContext } from 'react';

import { ArrowAngleRight } from '@zooplus/icons';

import LocResourcesContext from '../../common/contexts/LocResourcesContext';
import FiltersContext from '../contexts/FiltersContext';

import { FiltersDrawer } from './FiltersDrawer/FiltersDrawer';
import PetFilter from './PetFilter';

interface FiltersMenuProps {}

const FiltersMenu = ({}: FiltersMenuProps): JSX.Element => {
  const GLOBAL_PREFIX = 'loy-bp-rws-overview';
  const { showFilters, defaultView, onShowFilters } = useContext(FiltersContext);

  const { onFormatLocale } = useContext(LocResourcesContext);

  const moreFiltersCollapsed = () => {
    return (
      <div
        className={`${GLOBAL_PREFIX}_filter__more`}
        onClick={(e) => {
          onShowFilters?.(true, 'all');
        }}>
        {onFormatLocale?.('loy.rewards.shop.filter.more')}
        <ArrowAngleRight />
      </div>
    );
  };

  return (
    <React.Fragment>
      <PetFilter />
      {moreFiltersCollapsed()}
      {showFilters && <FiltersDrawer view={defaultView} />}
    </React.Fragment>
  );
};

export default FiltersMenu;
